// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MagnifyingGlass: React.FC<{
    size?: number;
    className?: string;
}> = ({ size = 36, className }) => (
    <svg className={className} focusable="false" viewBox="0 0 36 36" width={size} height={size}>
        <g fill="none" fillRule="evenodd">
            <circle cx="18" cy="18" r="18" fill="transparent" />
            <path
                fill="#EEEE"
                fillRule="nonzero"
                d="M18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0m0 .5C8.335.5.5 8.335.5 18S8.335 35.5 18 35.5 35.5 27.665 35.5 18 27.665.5 18 .5"
            />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M16.5 11a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 12a6.46 6.46 0 0 0 4.228-1.562l4.419 4.415a.5.5 0 0 0 .706 0 .5.5 0 0 0 0-.706l-4.416-4.419A6.499 6.499 0 0 0 16.5 10a6.5 6.5 0 1 0 0 13m-.5-3.5c0 .275.225.5.5.5s.5-.225.5-.5V17h2.5c.275 0 .5-.225.5-.5s-.225-.5-.5-.5H17v-2.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5V16h-2.5c-.275 0-.5.225-.5.5s.225.5.5.5H16z"
            />
        </g>
    </svg>
);

export default React.memo(MagnifyingGlass);
